/**
 * PersonDropdown Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectPeopleArray } from '../../../../services/people/selectors';

// Utils
import orderBy from '../../../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectOrderedData = createDeepEqualSelector(
    selectPeopleArray,
    peopleArrayState => orderBy(peopleArrayState, 'fullName')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    orderedDataState =>
        orderedDataState.map(({ id, fullName }) => ({
            key: id,
            text: fullName,
            value: `${id}`
        }))
);

export { selectOptions };
